import { cdnTemplate } from 'cdnPreprocessor';

export default function innerBanner() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: {
      type: '@',
    },
    templateUrl: cdnTemplate('/inner-banner.html'),
    link: (scope) => {
      scope.getClass = () => {
        let retVal;

        switch (scope.type) {
          case "about":
            retVal = "our-story";
            break;
          case "features":
            retVal = "features-banner";
            break;
          case "training":
            retVal = "training-banner";
            break;
          case "career":
            retVal = "career";
            break;
          case "press":
            retVal = "default press";
          break;
          case "store":
            retVal = "store-page";
          break;
          default:
            retVal = "default";
            break;
        }

        return retVal;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./source/client/layout-components/inner-banner/inner-banner.dir.js